export default __webpack_public_path__ + "2014e4a0c7dd04d939d117b4329e7468.png";